import { FC } from "react"

import { ReactComponent as IconChevronDown } from "@common_assets/svg/chevron-down.svg"
import { useTheme } from "@mui/material"

interface IExportRowChevronProps {
  isOpen: boolean
}

const ExportRowChevron: FC<IExportRowChevronProps> = ({ isOpen }) => {
  const theme = useTheme()

  return (
    <IconChevronDown
      style={{
        width: "16px",
        height: "16px",
        marginLeft: "auto",
        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.2s ease",
        color: theme.palette.text.secondary,
      }}
    />
  )
}

export default ExportRowChevron
